import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { AuthService } from './services/auth.service';
import { MojoAuthorizationService } from './services/mojo-authorization.service';

function initialize(authService: AuthService) {
  return () => authService.init();
}

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        MojoAuthorizationService,
        {
          provide: APP_INITIALIZER,
          useFactory: initialize,
          deps: [AuthService],
          multi: true,
        },
      ],
    };
  }
}
